import React from 'react';

type ModalGridProps = {
  children: React.ReactNode;
  gridGap: string;
  gridTemplateColumns: string;
  gridTemplateRows: string;
  height?: string;
};

const ModalGrid: React.FC<ModalGridProps> = ({
  children,
  gridGap,
  gridTemplateColumns,
  gridTemplateRows,
  height = 'calc(100vh - 368px)',
}: ModalGridProps) => {
  return (
    <div className="b-2">
      <div
        className="m3"
        style={{
          display: 'grid',
          gridGap,
          gridTemplateColumns,
          gridTemplateRows,
          height,
          justifyContent: 'space-evenly',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default ModalGrid;
